import { connect } from 'react-redux';
import { compose } from 'recompose';

const mapStateToProps = state => ({
    backendConfig: state.backendConfig
  });

export  const connectBackendConfig = compose(
    connect(mapStateToProps),
);




// WEBPACK FOOTER //
// ./src/Common/connectBackendConfig.js